export default class DJAALinesRowData {
    constructor(value) {
        this.chargeType = value.chargeType[0] || "";
        this.raNumber = value.ranumber[0] || "";
        this.brand = value.brand[0] || "";
        this.adjCountry = value.adjCountry[0] || "";
        this.chargedCountry = value.chargedCountry[0] || "";
        this.adjRef = value.adjRef[0] || "";
        this.batchRef = value.batchRef[0] || "";
        this.billAmt = value.billAmt[0] || "";
        this.rentAmt = value.rentAmt[0] || "";
        this.chargePeriod = value.chargePeriod[0] || "";
        this.fxAdj = value.fxAdj[0] || "";
        this.fxGainLoss = value.fxgainLoss[0] || "";
        this.rechargeReason = value.rechargeReason[0] || "";
        this.imageNowLink = value.imageNowLink[0] || "";
        this.imageSource = value.imageSource[0] || "";
    }
}